export const themeOptionFactory = (theme) => ({
  assets: {
    empty: {
      department: {
        icon_path:
          "M21.9206 23.331L20.4602 7.06712C20.4204 6.62296 20.0481 6.28276 19.6022 6.28276H16.5906V4.92446C16.5906 2.393 14.5312 0.333496 11.9998 0.333496C9.4686 0.333496 7.40944 2.393 7.40944 4.92446V6.28276H4.3957C3.94982 6.28276 3.57757 6.62296 3.53771 7.06712L2.07156 23.395C2.04997 23.636 2.1306 23.8748 2.29381 24.0532C2.45702 24.2317 2.68777 24.3334 2.92954 24.3334H21.0685C21.0692 24.3334 21.0701 24.3334 21.0708 24.3334C21.5466 24.3334 21.9322 23.9477 21.9322 23.472C21.9321 23.4241 21.9282 23.3769 21.9206 23.331ZM9.13229 4.92446C9.13229 3.34299 10.4187 2.05635 11.9999 2.05635C13.5813 2.05635 14.8678 3.34299 14.8678 4.92446V6.28276H9.13229V4.92446ZM3.87183 22.6106L5.18327 8.00562H7.40944V9.54608C7.40944 10.0218 7.79501 10.4075 8.27087 10.4075C8.74672 10.4075 9.13229 10.0218 9.13229 9.54608V8.00562H14.8678V9.54608C14.8678 10.0218 15.2534 10.4075 15.7292 10.4075C16.2051 10.4075 16.5907 10.0218 16.5907 9.54608V8.00562H18.8148L20.1262 22.6106H3.87183Z",
      },
    },
  },
  components: {
    EmDepartmentStorePage: {
      styleOverrides: {
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          height: "100%",
          backgroundColor: theme.palette.background.default,
        },
        occupantCardsContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridTemplateColumns: "repeat(4,  minmax(100px,1fr))",
          gap: theme.spacing(2),
          height: "100%",
          paddingBottom: theme.spacing(9.5),
          overflowY: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          flex: "1",
        },
        gridItem: {
          display: "block",
          height: "262px",
          aspectRatio: "1 / 1.25",
          boxShadow: "0px 8px 24px 0px rgba(155, 155, 155, 0.15)",
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            color: theme.palette.text.primary,
            paddingRight: theme.spacing(5.25),
            fontSize: "min(1.125rem, 3vw)",
            textTransform: "uppercase",
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "50px",
            height: "50px",
          },
          "& .MuiCardActionArea-root": {
            "&:after": {
              display: "none",
            },
          },
          "& .MuiCardHeader-root": {
            height: "30%",
            paddingTop: theme.spacing(0),
            paddingLeft: theme.spacing(4),
            background: theme.palette.common.white,
            alignItems: "flex-start",
            position: "relative",
            "& .location-text": {
              position: "absolute",
              bottom: "-16px",
              right: "3px",
              padding: theme.spacing(0.5, 1.25),
              overflow: "hidden",
              background: theme.palette.common.black,
              color: theme.palette.common.white,
              marginLeft: "auto",
              width: "42px",
              height: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopLeftRadius: "20px",
              fontSize: "1.2rem",
            },
            "& .MuiCardHeader-content": {
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
              marginBottom: theme.spacing(-0.5),
              marginRight: theme.spacing(-0.5),
            },
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "70%",
            backgroundColor: theme.palette.secondary.main,
          },
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "250px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridTemplateColumns: "repeat(auto-fill, minmax(390px, 1fr))",
          gridTemplateRows: "max-content",
          gap: theme.spacing(2),
          paddingBottom: theme.spacing(6.25),
          overflowY: "auto",
          height: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "@media (max-width: 400px)": {
            gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
          },
        },
        sectionContentWrapper: {
          height: "100%",
        },
      },
    },
  },
})
